{
  "about.blocks": "Serbidores moderados",
  "about.contact": "Cuntatu:",
  "about.default_locale": "Predefinidu",
  "about.disclaimer": "Mastodon est software de còdighe lìberu e unu màrchiu de Mastodon gGmbH.",
  "about.domain_blocks.no_reason_available": "Peruna resone a disponimentu",
  "about.domain_blocks.preamble": "Mastodon ti permitit de bìdere su cuntenutu de utentes de cale si siat àteru serbidore de su fediversu. Custas sunt etzetziones fatas in custu serbidore ispetzìficu.",
  "about.domain_blocks.silenced.explanation": "As a bìdere profilos e cuntenutos dae custu serbidore isceti chi ddos chircas o detzides de ddu sighire.",
  "about.domain_blocks.silenced.title": "Limitadu",
  "about.domain_blocks.suspended.explanation": "Perunu datu de custu serbidore at a èssere protzessadu, immagasinadu o cuncambiadu; est impossìbile duncas cale si siat interatzione o comunicatzione cun is utentes de custu serbidore.",
  "about.domain_blocks.suspended.title": "Suspèndidu",
  "about.language_label": "Idioma",
  "about.not_available": "Custa informatzione no est istada posta a disponimentu in custu serbidore.",
  "about.powered_by": "Rete sotziale detzentralizada impulsada dae {mastodon}",
  "about.rules": "Règulas de su serbidore",
  "account.account_note_header": "Nota personale",
  "account.add_or_remove_from_list": "Agiunghe o boga dae is listas",
  "account.badges.bot": "Automatizadu",
  "account.badges.group": "Grupu",
  "account.block": "Bloca @{name}",
  "account.block_domain": "Bloca su domìniu {domain}",
  "account.block_short": "Bloca",
  "account.blocked": "Blocadu",
  "account.cancel_follow_request": "Annulla sa sighidura",
  "account.copy": "Còpia su ligòngiu a su profilu",
  "account.direct": "Mèntova a @{name} in privadu",
  "account.disable_notifications": "Non mi notìfiches prus cando @{name} pùblichet messàgios",
  "account.edit_profile": "Modìfica profilu",
  "account.enable_notifications": "Notìfica·mi cando @{name} pùblicat messàgios",
  "account.endorse": "Cussìgia in su profilu tuo",
  "account.familiar_followers_many": "Sighidu dae {name1}, {name2} e {othersCount, plural,one {un'àtera persone chi connosches} other {àteras # persones chi connosches}}",
  "account.familiar_followers_one": "Sighidu dae {name1}",
  "account.familiar_followers_two": "Sighidu dae {name1} e {name2}",
  "account.featured": "In evidèntzia",
  "account.featured.accounts": "Profilos",
  "account.follow": "Sighi",
  "account.follow_back": "Sighi tue puru",
  "account.followers": "Sighiduras",
  "account.followers.empty": "Nemos sighit ancora custa persone.",
  "account.followers_counter": "{count, plural, one {{counter} sighidura} other {{counter} sighiduras}}",
  "account.followers_you_know_counter": "{counter} chi connosches",
  "account.following": "Sighende",
  "account.following_counter": "{count, plural, one {sighende a {counter}} other {sighende a {counter}}}",
  "account.follows.empty": "Custa persone non sighit ancora a nemos.",
  "account.follows_you": "Ti sighit",
  "account.go_to_profile": "Bae a su profilu",
  "account.hide_reblogs": "Cua is cumpartziduras de @{name}",
  "account.in_memoriam": "In memoriam.",
  "account.joined_short": "At aderidu",
  "account.languages": "Muda is idiomas sutiscritos",
  "account.link_verified_on": "Sa propiedade de custu ligòngiu est istada controllada su {date}",
  "account.locked_info": "S'istadu de riservadesa de custu contu est istadu cunfiguradu comente blocadu. Sa persone chi tenet sa propiedade revisionat a manu chie dda podet sighire.",
  "account.media": "Cuntenutu multimediale",
  "account.mention": "Mèntova a @{name}",
  "account.moved_to": "{name} at indicadu chi su contu nou issoro immoe est:",
  "account.mute": "Pone a @{name} a sa muda",
  "account.mute_notifications_short": "Pone is notìficas a sa muda",
  "account.mute_short": "A sa muda",
  "account.muted": "A sa muda",
  "account.no_bio": "Peruna descritzione frunida.",
  "account.open_original_page": "Aberi sa pàgina originale",
  "account.posts": "Publicatziones",
  "account.remove_from_followers": "Cantzella a {name} dae is sighiduras",
  "account.report": "Signala @{name}",
  "account.requested_follow": "{name} at dimandadu de ti sighire",
  "account.share": "Cumpartzi su profilu de @{name}",
  "account.show_reblogs": "Ammustra is cumpartziduras de @{name}",
  "account.statuses_counter": "{count, plural, one {{counter} publicatzione} other {{counter} publicatziones}}",
  "account.unblock": "Isbloca a @{name}",
  "account.unblock_domain": "Isbloca su domìniu {domain}",
  "account.unblock_domain_short": "Isbloca",
  "account.unblock_short": "Isbloca",
  "account.unendorse": "Non cussiges in su profilu",
  "account.unfollow": "Non sigas prus",
  "account.unmute": "Torra a ativare a @{name}",
  "account.unmute_notifications_short": "Ativa is notìficas",
  "account.unmute_short": "Ativa su sonu",
  "account_note.placeholder": "Incarca pro agiùnghere una nota",
  "admin.dashboard.daily_retention": "Tassu de ritentzione de is utentes a pustis de sa registratzione",
  "admin.dashboard.monthly_retention": "Tassu de ritentzione de utentes pro mese a pustis de sa registratzione",
  "admin.dashboard.retention.average": "Mèdiu",
  "admin.dashboard.retention.cohort": "Mese de registratzione",
  "admin.dashboard.retention.cohort_size": "Utentes noos",
  "admin.impact_report.instance_accounts": "Contos de profilu chi custu diat cantzellare",
  "admin.impact_report.instance_followers": "Sighiduras chi is utentes nostros diant pèrdere",
  "admin.impact_report.instance_follows": "Sighiduras chi is utentes issoro diant pèrdere",
  "admin.impact_report.title": "Resumu de s'impatu",
  "alert.rate_limited.message": "Torra·bi a proare a pustis de {retry_time, time, medium}.",
  "alert.rate_limited.title": "Màssimu de rechestas barigadu",
  "alert.unexpected.message": "Ddoe est istada una faddina.",
  "alert.unexpected.title": "Oh!",
  "alt_text_badge.title": "Testu alternativu",
  "alt_text_modal.add_alt_text": "Agiunghe testu alternativu",
  "alt_text_modal.add_text_from_image": "Agiunghe testu dae un'immàgine",
  "alt_text_modal.cancel": "Annulla",
  "alt_text_modal.change_thumbnail": "Càmbia sa miniadura",
  "alt_text_modal.done": "Fatu",
  "announcement.announcement": "Annùntziu",
  "annual_report.summary.most_used_app.most_used_app": "aplicatzione prus impreada",
  "annual_report.summary.most_used_hashtag.most_used_hashtag": "eticheta prus impreada",
  "annual_report.summary.new_posts.new_posts": "publicatziones noas",
  "annual_report.summary.percentile.we_wont_tell_bernie": "No dd'amus a nàrrere a Bernie.",
  "attachments_list.unprocessed": "(non protzessadu)",
  "audio.hide": "Cua s'àudio",
  "block_modal.remote_users_caveat": "Amus a pedire a su serbidore {domain} de rispetare sa detzisione tua. Nointames custu, su rispetu no est garantidu ca unos cantos serbidores diant pòdere gestire is blocos de manera diferente. Is publicatzione pùblicas diant pòdere ancora èssere visìbiles a is utentes chi no ant fatu s'atzessu.",
  "block_modal.show_less": "Ammustra·nde prus pagu",
  "block_modal.show_more": "Ammustra·nde prus",
  "block_modal.they_will_know": "Non podent bìdere chi ddos as blocadu.",
  "block_modal.title": "Boles blocare s'utente?",
  "boost_modal.combo": "Podes incarcare {combo} pro brincare custu sa borta chi benit",
  "boost_modal.reblog": "Boles potentziare sa publicatzione?",
  "boost_modal.undo_reblog": "Boles tzessare de potentziare sa publicatzione?",
  "bundle_column_error.copy_stacktrace": "Còpia s'informe de faddina",
  "bundle_column_error.error.body": "Sa pàgina pedida non faghiat a dda renderizare. Diat pòdere èssere pro neghe de una faddina in su còdighe nostru, o de unu problema de cumpatibilidade de su navigadore.",
  "bundle_column_error.error.title": "Oh, no!",
  "bundle_column_error.network.body": "Ddoe est àpidu un'errore proende a carrigare custa pàgina. Custu diat pòdere derivare dae unu problema temporàneu cun sa connessione ìnternet tua a su serbidore.",
  "bundle_column_error.network.title": "Faddina de connessione",
  "bundle_column_error.retry": "Torra·bi a proare",
  "bundle_column_error.return": "Torra a sa pàgina printzipale",
  "bundle_column_error.routing.body": "Impossìbile agatare sa pàgina rechesta. Seguru chi s'URL in sa barra de indiritzos est curretu?",
  "bundle_column_error.routing.title": "404",
  "bundle_modal_error.close": "Serra",
  "bundle_modal_error.message": "Faddina in su carrigamentu de custu ischermu.",
  "bundle_modal_error.retry": "Torra·bi a proare",
  "closed_registrations.other_server_instructions": "Dae chi Mastodon est detzentralizadu, podes creare unu contu in un'àteru serbidore e interagire cun custu.",
  "closed_registrations_modal.description": "Sa creatzione de contos in {domain} no est possìbile in custu momentu, però tene in cunsideru chi non tenes bisòngiu de unu contu ispetzìficu in {domain} pro impreare Mastodon.",
  "closed_registrations_modal.find_another_server": "Agata un'àteru serbidore",
  "closed_registrations_modal.title": "Su registru a Mastodon",
  "column.about": "Informatziones",
  "column.blocks": "Persones blocadas",
  "column.bookmarks": "Sinnalibros",
  "column.community": "Lìnia de tempus locale",
  "column.create_list": "Crea una lista",
  "column.direct": "Mentziones privadas",
  "column.directory": "Nàviga in is profilos",
  "column.domain_blocks": "Domìnios blocados",
  "column.edit_list": "Modifica sa lista",
  "column.favourites": "Preferidos",
  "column.firehose": "Publicatziones in direta",
  "column.follow_requests": "Rechestas de sighidura",
  "column.home": "Printzipale",
  "column.list_members": "Gesti is persones de sa lista",
  "column.lists": "Listas",
  "column.mutes": "Persones a sa muda",
  "column.notifications": "Notìficas",
  "column.pins": "Publicatziones apicadas",
  "column.public": "Lìnia de tempus federada",
  "column_back_button.label": "A coa",
  "column_header.hide_settings": "Cua is cunfiguratziones",
  "column_header.moveLeft_settings": "Moe sa colunna a manca",
  "column_header.moveRight_settings": "Moe sa colunna a dereta",
  "column_header.pin": "Apica",
  "column_header.show_settings": "Ammustra is cunfiguratziones",
  "column_header.unpin": "Boga dae pitzu",
  "column_search.cancel": "Annulla",
  "community.column_settings.local_only": "Isceti locale",
  "community.column_settings.media_only": "Isceti multimediale",
  "community.column_settings.remote_only": "Isceti remotu",
  "compose.language.change": "Càmbia s'idioma",
  "compose.language.search": "Chirca idiomas...",
  "compose.published.body": "Publicadu.",
  "compose.published.open": "Aberi",
  "compose.saved.body": "Publicatzione sarvada.",
  "compose_form.direct_message_warning_learn_more": "Àteras informatziones",
  "compose_form.encryption_warning": "Is publicatziones a Mastodon no sunt critografados a nodu terminale. Non cumpartzas informatziones delicadas in Mastodon.",
  "compose_form.hashtag_warning": "Custa publicatzione no at a èssere ammustrada in peruna eticheta, dae chi no est pùblica. Isceti is publicatziones pùblicas podent èssere chircadas cun etichetas.",
  "compose_form.lock_disclaimer": "Su contu tuo no est {locked}. Cale si siat persone ti podet sighire pro bìdere is messàgios tuos chi imbies a sa gente chi ti sighit.",
  "compose_form.lock_disclaimer.lock": "blocadu",
  "compose_form.placeholder": "A ite ses pensende?",
  "compose_form.poll.duration": "Longària de su sondàgiu",
  "compose_form.poll.multiple": "Sèberu mùltiplu",
  "compose_form.poll.option_placeholder": "Optzione {number}",
  "compose_form.poll.single": "Sèberu ùnicu",
  "compose_form.poll.switch_to_multiple": "Muda su sondàgiu pro permìtere multi-optziones",
  "compose_form.poll.switch_to_single": "Muda su sondàgiu pro permìtere un'optzione isceti",
  "compose_form.poll.type": "Istile",
  "compose_form.publish": "Pùblica",
  "compose_form.reply": "Risponde",
  "compose_form.save_changes": "Atualiza",
  "compose_form.spoiler.marked": "Boga avisu de cuntenutu",
  "compose_form.spoiler.unmarked": "Agiunghe avisu de cuntenutu",
  "compose_form.spoiler_placeholder": "Avisu de cuntenutu (optzionale)",
  "confirmation_modal.cancel": "Annulla",
  "confirmations.block.confirm": "Bloca",
  "confirmations.delete.confirm": "Cantzella",
  "confirmations.delete.message": "Seguru chi boles cantzellare custa publicatzione?",
  "confirmations.delete.title": "Cantzellare sa publicatzione?",
  "confirmations.delete_list.confirm": "Cantzella",
  "confirmations.delete_list.message": "Seguru chi boles cantzellare custa lista in manera permanente?",
  "confirmations.delete_list.title": "Cantzellare sa lista?",
  "confirmations.discard_draft.confirm": "Iscarta e sighi",
  "confirmations.discard_draft.edit.cancel": "Sighi cun s'editzione",
  "confirmations.discard_edit_media.confirm": "Iscarta",
  "confirmations.discard_edit_media.message": "Tenes modìficas non sarvadas a is descritziones o a is anteprimas de is cuntenutos, ddas boles iscartare su matessi?",
  "confirmations.logout.confirm": "Essi·nche",
  "confirmations.logout.message": "Seguru chi boles essire?",
  "confirmations.logout.title": "Boles serrare sa sessione?",
  "confirmations.mute.confirm": "A sa muda",
  "confirmations.redraft.confirm": "Cantzella e torra a fàghere",
  "confirmations.redraft.message": "Seguru chi boles cantzellare e torrare a fàghere custa publicatzione? As a pèrdere is preferidos e is cumpartziduras, e is rispostas a su messàgiu originale ant a abarrare òrfanas.",
  "confirmations.redraft.title": "Boles cantzellare e torrare a iscrìere sa publicatzione?",
  "confirmations.unfollow.confirm": "Non sigas prus",
  "content_warning.hide": "Cua sa publicatzione",
  "content_warning.show": "Ammustra·dda su pròpiu",
  "conversation.delete": "Cantzella arresonada",
  "conversation.mark_as_read": "Signala comente lèghidu",
  "conversation.open": "Ammustra arresonada",
  "conversation.with": "Cun {names}",
  "copy_icon_button.copied": "Copiadu in punta de billete",
  "copypaste.copied": "Copiadu",
  "copypaste.copy_to_clipboard": "Còpia in punta de billete",
  "directory.federated": "Dae unu fediversu connotu",
  "directory.local": "Isceti dae {domain}",
  "directory.new_arrivals": "Arribos noos",
  "directory.recently_active": "Cun atividade dae pagu",
  "disabled_account_banner.account_settings": "Cunfiguratziones de su contu",
  "disabled_account_banner.text": "Su contu tuo {disabledAccount} no est ativu.",
  "dismissable_banner.community_timeline": "Custas sunt is publicatziones pùblicas prus reghentes dae gente cun contu in {domain}.",
  "dismissable_banner.dismiss": "Iscarta",
  "domain_block_modal.block": "Bloca su serbidore",
  "domain_block_modal.block_account_instead": "Bloca imbetzes a @{name}",
  "domain_block_modal.they_can_interact_with_old_posts": "Is persones de custu serbidore podent ancora interagire cun is publicatziones betzas tuas.",
  "domain_block_modal.they_cant_follow": "Perunu dae custu serbidore ti podet sighire.",
  "domain_block_modal.they_wont_know": "No ant a ischire chi t'ant blocadu.",
  "domain_block_modal.title": "Boles blocare su domìniu?",
  "domain_block_modal.you_wont_see_posts": "No as a bìdere publicatziones o notìficas dae utentes in custu serbidore.",
  "domain_pill.activitypub_lets_connect": "Ti permitit de ti collegare e de interagire cun persones no isceti in Mastodon, ma in aplicatziones sotziales diferentes puru.",
  "domain_pill.activitypub_like_language": "ActivityPub est a tipu sa limba chi Mastodon chistionat cun àteras retes sotziales.",
  "domain_pill.server": "Serbidore",
  "domain_pill.their_handle": "S'identificadore suo:",
  "domain_pill.their_server": "Sa domo digitale sua, in ue istant totu is publicatziones suas.",
  "domain_pill.username": "Nòmine de utente",
  "domain_pill.whats_in_a_handle": "Ite est un'identificadore?",
  "domain_pill.your_handle": "S'identificadore tuo:",
  "domain_pill.your_server": "Sa domo digitale tua, in ue istant totu is publicatziones tuas. Custa non t'agradat? Tràmuda serbidore in cale si siat momentu e bati·ti fintzas in fatu is sighidores tuos.",
  "domain_pill.your_username": "S'identificadore ùnicu tuo in custu serbidore. Si podent agatare utentes cun su matessi nòmine de utente in àteros serbidores.",
  "embed.instructions": "Inserta custa publicatzione in su situ web tuo copiende su còdighe de suta.",
  "embed.preview": "At a aparèssere aici:",
  "emoji_button.activity": "Atividade",
  "emoji_button.clear": "Isbòida",
  "emoji_button.custom": "Personalizadu",
  "emoji_button.flags": "Banderas",
  "emoji_button.food": "Mandigòngiu e bufòngiu",
  "emoji_button.label": "Inserta un'emoji",
  "emoji_button.nature": "Natura",
  "emoji_button.not_found": "Perunu emoji agatadu",
  "emoji_button.objects": "Ogetos",
  "emoji_button.people": "Gente",
  "emoji_button.recent": "Impreadu a fitianu",
  "emoji_button.search": "Chirca...",
  "emoji_button.search_results": "Resurtados de sa chirca",
  "emoji_button.symbols": "Sìmbulos",
  "emoji_button.travel": "Biàgios e logos",
  "empty_column.account_suspended": "Contu suspèndidu",
  "empty_column.account_timeline": "Peruna publicatzione inoghe!",
  "empty_column.account_unavailable": "Su profilu no est a disponimentu",
  "empty_column.blocks": "No as blocadu ancora nemos.",
  "empty_column.bookmarked_statuses": "Non tenes ancora peruna publicatzione in is marcadores. Cando nd'as a agiùnghere una, at a èssere ammustrada inoghe.",
  "empty_column.community": "Sa lìnia de tempus locale est bòida. Iscrie inoghe pro cumintzare sa festa!",
  "empty_column.domain_blocks": "Non tenes ancora perunu domìniu blocadu.",
  "empty_column.follow_requests": "Non tenes ancora peruna rechesta de sighidura. Cando nd'as a retzire una, at a èssere ammustrada inoghe.",
  "empty_column.hashtag": "Ancora nudda in custa eticheta.",
  "empty_column.home": "Sa lìnia de tempus printzipale tua est bòida. Visita {public} o imprea sa chirca pro cumintzare e agatare àteras persones.",
  "empty_column.list": "Nudda ancora in custa lista. Cando is persones de custa lista ant a publicare, is publicatziones ant a aparèssere inoghe.",
  "empty_column.mutes": "No as postu ancora nemos a sa muda.",
  "empty_column.notifications": "Non tenes ancora peruna notìfica. Chistiona cun una persone pro cumintzare un'arresonada.",
  "empty_column.public": "Nudda inoghe. Iscrie calicuna cosa pùblica, o sighi àteras persones de àteros serbidores pro prenare custu ispàtziu",
  "error.unexpected_crash.explanation": "A càusa de una faddina in su còdighe nostru o unu problema de cumpatibilidade de su navigadore, custa pàgina diat pòdere no èssere ammustrada in manera curreta.",
  "error.unexpected_crash.explanation_addons": "Custa pàgina diat pòdere no èssere ammustrada comente si tocat. Custa faddina est probàbile chi dipendat dae un'estensione de su navigadore o dae ainas automàticas de tradutzione.",
  "error.unexpected_crash.next_steps": "Proa de torrare a carrigare sa pàgina. Si custu no acontza su problema, podes chircare de impreare Mastodon in unu navigadore diferente o in un'aplicatzione nativa.",
  "error.unexpected_crash.next_steps_addons": "Proa a ddos disabilitare e torra a carrigare sa pàgina. Si custu no acontzat su problema, podes chircare de impreare Mastodon in unu navigadore diferente o in un'aplicatzione nativa.",
  "errors.unexpected_crash.copy_stacktrace": "Còpia stacktrace in punta de billete",
  "errors.unexpected_crash.report_issue": "Sinnala unu problema",
  "explore.suggested_follows": "Gente",
  "explore.trending_links": "Noas",
  "explore.trending_statuses": "Publicatziones",
  "explore.trending_tags": "Etichetas",
  "filter_modal.added.context_mismatch_title": "Su cuntestu non currispondet.",
  "filter_modal.added.expired_title": "Filtru iscadidu.",
  "filter_modal.added.review_and_configure_title": "Cunfiguratziones de filtru",
  "filter_modal.added.settings_link": "pàgina de cunfiguratzione",
  "filter_modal.added.short_explanation": "Custa publicatzione est istada agiunta a sa categoria de filtros imbeniente: {title}.",
  "filter_modal.added.title": "Filtru agiuntu!",
  "filter_modal.select_filter.expired": "iscadidu",
  "filter_modal.select_filter.prompt_new": "Categoria noa: {name}",
  "filter_modal.select_filter.search": "Chirca o crea",
  "filter_modal.select_filter.subtitle": "Imprea una categoria chi esistit giai o crea·nde una",
  "filter_modal.select_filter.title": "Filtra custa publicatzione",
  "filter_modal.title.status": "Filtra una publicatzione",
  "filtered_notifications_banner.title": "Notìficas filtradas",
  "firehose.all": "Totus",
  "firehose.local": "Custu serbidore",
  "firehose.remote": "Àteros serbidores",
  "follow_request.authorize": "Autoriza",
  "follow_request.reject": "Refuda",
  "follow_requests.unlocked_explanation": "Fintzas si su contu tuo no est blocadu, su personale de {domain} at pensadu chi forsis bolias revisionare a manu is rechestas de custos contos.",
  "follow_suggestions.curated_suggestion": "Sa seletzione de s'iscuadra de traballu",
  "follow_suggestions.dismiss": "No ammustres prus",
  "follow_suggestions.featured_longer": "Seberadu a manu dae s'iscuadra de {domain}",
  "follow_suggestions.friends_of_friends_longer": "Populare intre persones chi sighis",
  "follow_suggestions.hints.featured": "Custu profilu est istadu seberadu a manu dae s'iscuadra {domain}.",
  "follow_suggestions.personalized_suggestion": "Cussìgiu personalizadu",
  "follow_suggestions.popular_suggestion": "Cussìgiu populare",
  "follow_suggestions.popular_suggestion_longer": "Populare a {domain}",
  "follow_suggestions.similar_to_recently_followed_longer": "Profilos sìmiles a is chi as sighidu de reghente",
  "follow_suggestions.view_all": "Ammustra totu",
  "follow_suggestions.who_to_follow": "Chie sighire",
  "followed_tags": "Etichetas sighidas",
  "footer.about": "Informatziones",
  "footer.directory": "Diretòriu de profilos",
  "footer.get_app": "Otene s'aplicatzione",
  "footer.keyboard_shortcuts": "Incurtzaduras de tecladu",
  "footer.privacy_policy": "Polìtica de riservadesa",
  "footer.source_code": "Ammustra su còdighe de orìgine",
  "footer.status": "Istadu",
  "footer.terms_of_service": "Cunditziones de su servìtziu",
  "generic.saved": "Sarvadu",
  "getting_started.heading": "Comente cumintzare",
  "hashtag.admin_moderation": "Aberi s'interfache de moderatzione pro #{name}",
  "hashtag.browse": "Nàviga in is publicatziones de #{hashtag}",
  "hashtag.browse_from_account": "Nàviga in is publicatziones de @{name} in #{hashtag}",
  "hashtag.column_header.tag_mode.all": "e {additional}",
  "hashtag.column_header.tag_mode.any": "o {additional}",
  "hashtag.column_header.tag_mode.none": "sena {additional}",
  "hashtag.column_settings.select.no_options_message": "Perunu cussìgiu agatadu",
  "hashtag.column_settings.select.placeholder": "Introdue etichetas…",
  "hashtag.column_settings.tag_mode.all": "Totu custos",
  "hashtag.column_settings.tag_mode.any": "Cale si siat de custos",
  "hashtag.column_settings.tag_mode.none": "Perunu de custos",
  "hashtag.column_settings.tag_toggle": "Include etichetas additzionales pro custa colunna",
  "hashtag.counter_by_accounts": "{count, plural, one {{counter} partetzipante} other {{counter} partetzipantes}}",
  "hashtag.counter_by_uses": "{count, plural, one {{counter} publicatzione} other {{counter} publicatziones}}",
  "hashtag.counter_by_uses_today": "{count, plural, one {{counter} publicatzione} other {{counter} publicatziones}} oe",
  "hashtag.feature": "In evidèntzia in su profilu",
  "hashtag.follow": "Sighi su hashtag",
  "hashtag.mute": "Pone #{hashtag} a sa muda",
  "hashtag.unfeature": "No ddu pòngias in evidèntzia in su profilu",
  "hashtag.unfollow": "Non sigas prus s'eticheta",
  "hashtags.and_other": "… e {count, plural, one {un'àteru} other {àteros #}}",
  "hints.profiles.posts_may_be_missing": "Podet èssere chi ammanchent tzertas publicatziones de custu profilu.",
  "hints.profiles.see_more_posts": "Bide prus publicatziones a {domain}",
  "home.column_settings.show_reblogs": "Ammustra is cumpartziduras",
  "home.column_settings.show_replies": "Ammustra rispostas",
  "home.hide_announcements": "Cua annùntzios",
  "home.pending_critical_update.body": "Atualiza su serbidore Mastodon tuo su prima possìbile.",
  "home.pending_critical_update.link": "Ammustra is atualizatziones",
  "home.pending_critical_update.title": "Atualizatzione de seguresa crìtica a disponimentu.",
  "home.show_announcements": "Ammustra annùntzios",
  "ignore_notifications_modal.disclaimer": "Mastodon non podet informare is utentes chi as innioradu is notìficas issoro. Inniorare notìficas no at a evitare chi s'imbient is messàgios.",
  "ignore_notifications_modal.filter_instead": "Opuru filtra",
  "ignore_notifications_modal.filter_to_act_users": "As a pòdere ancora atzetare, refudare o sinnalare a utentes",
  "ignore_notifications_modal.filter_to_avoid_confusion": "Filtrare agiudat a evitare possìbiles confusiones",
  "info_button.label": "Agiudu",
  "interaction_modal.go": "Sighi",
  "interaction_modal.no_account_yet": "Non tenes galu perunu contu?",
  "interaction_modal.on_another_server": "In un'àteru serbidore",
  "interaction_modal.on_this_server": "In custu serbidore",
  "interaction_modal.username_prompt": "Pro es., {example}",
  "intervals.full.days": "{number, plural, one {# die} other {# dies}}",
  "intervals.full.hours": "{number, plural, one {# ora} other {# oras}}",
  "intervals.full.minutes": "{number, plural, one {# minutu} other {# minutos}}",
  "keyboard_shortcuts.back": "Nàviga a coa",
  "keyboard_shortcuts.blocked": "Aberi sa lista de persones blocadas",
  "keyboard_shortcuts.boost": "Potèntzia sa publicatzione",
  "keyboard_shortcuts.column": "Atzentra sa colunna",
  "keyboard_shortcuts.compose": "Atzentra s'àrea de cumpositzione de testu",
  "keyboard_shortcuts.description": "Descritzione",
  "keyboard_shortcuts.down": "Move in bàsciu in sa lista",
  "keyboard_shortcuts.enter": "Aberi una publicatzione",
  "keyboard_shortcuts.favourite": "Publicatzione preferida",
  "keyboard_shortcuts.favourites": "Aberi sa lista de preferidos",
  "keyboard_shortcuts.federated": "Aberi sa lìnia de tempus federada",
  "keyboard_shortcuts.heading": "Incurtzaduras de tecladu",
  "keyboard_shortcuts.home": "Aberi sa lìnia de tempus printzipale",
  "keyboard_shortcuts.hotkey": "Tecla de atzessu diretu",
  "keyboard_shortcuts.legend": "Ammustra custa didascalia",
  "keyboard_shortcuts.local": "Aberi sa lìnia de tempus locale",
  "keyboard_shortcuts.mention": "Mèntova a s'atributzione",
  "keyboard_shortcuts.muted": "Aberi sa lista de persones a sa muda",
  "keyboard_shortcuts.my_profile": "Aberi su profilu tuo",
  "keyboard_shortcuts.notifications": "Aberi sa colunna de notificatziones",
  "keyboard_shortcuts.open_media": "Aberi is elementos multimediales",
  "keyboard_shortcuts.pinned": "Aberi sa lista de publicatziones apicadas",
  "keyboard_shortcuts.profile": "Aberi su profilu de s'autore",
  "keyboard_shortcuts.reply": "Risponde a sa publicatzioe",
  "keyboard_shortcuts.requests": "Aberi sa lista de rechestas de sighiduras",
  "keyboard_shortcuts.search": "Atzentra sa barra de chirca",
  "keyboard_shortcuts.spoilers": "Ammustra/cua su campu AC",
  "keyboard_shortcuts.start": "Aberi sa colunna \"Cumintza\"",
  "keyboard_shortcuts.toggle_hidden": "Ammustra o cua su testu de is AC",
  "keyboard_shortcuts.toggle_sensitivity": "Ammustra/cua elementos multimediales",
  "keyboard_shortcuts.toot": "Cumintza a iscrìere una publicatzione noa",
  "keyboard_shortcuts.translate": "pro tradùere una publicatzione",
  "keyboard_shortcuts.unfocus": "Essi de s'àrea de cumpositzione de testu o de chirca",
  "keyboard_shortcuts.up": "Move in susu in sa lista",
  "lightbox.close": "Serra",
  "lightbox.next": "Imbeniente",
  "lightbox.previous": "Pretzedente",
  "lightbox.zoom_in": "Ismànnia finas a sa mannària atuale",
  "limited_account_hint.title": "Custu profilu est istadu cuadu dae sa moderatzione de {domain}.",
  "link_preview.author": "Dae {name}",
  "link_preview.shares": "{count, plural, one {{counter} publicatzione} other {{counter} publicatziones}}",
  "lists.delete": "Cantzella sa lista",
  "lists.edit": "Modìfica sa lista",
  "lists.remove_member": "Cantzella",
  "lists.replies_policy.followed": "Cale si siat persone chi sighis",
  "lists.replies_policy.list": "Persones de sa lista",
  "lists.replies_policy.none": "Nemos",
  "lists.save": "Sarva",
  "lists.search": "Chirca",
  "lists.show_replies_to": "Include rispostas dae gente de sa lista a",
  "load_pending": "{count, plural, one {# elementu nou} other {# elementos noos}}",
  "loading_indicator.label": "Carrighende…",
  "media_gallery.hide": "Cua",
  "moved_to_account_banner.text": "Su contu tuo {disabledAccount} est disativadu in custu momentu ca est istadu tramudadu a {movedToAccount}.",
  "mute_modal.hide_from_notifications": "Cua dae is notìficas",
  "mute_modal.hide_options": "Cua is optziones",
  "mute_modal.indefinite": "Fintzas a cando no apo a torrare a ativare is notìficas",
  "mute_modal.show_options": "Ammustra is optziones",
  "mute_modal.they_can_mention_and_follow": "Ti podent mentovare e sighire, però no ddos as a bìdere.",
  "mute_modal.they_wont_know": "No ant a ischire chi ddos as postu a sa muda.",
  "mute_modal.title": "Boles pònnere a custu contu a sa muda?",
  "mute_modal.you_wont_see_mentions": "No as a bìdere is publicatziones chi mèntovent a custa persone.",
  "mute_modal.you_wont_see_posts": "At a pòdere bìdere is publicatziones tuas, però tue no as a bìdere cussas suas.",
  "navigation_bar.about": "Informatziones",
  "navigation_bar.account_settings": "Crae e seguresa",
  "navigation_bar.administration": "Amministratzione",
  "navigation_bar.advanced_interface": "Aberi s'interfache web avantzada",
  "navigation_bar.automated_deletion": "Cantzelladura automàtica de publicatziones",
  "navigation_bar.blocks": "Persones blocadas",
  "navigation_bar.bookmarks": "Sinnalibros",
  "navigation_bar.direct": "Mentziones privadas",
  "navigation_bar.domain_blocks": "Domìnios blocados",
  "navigation_bar.favourites": "Preferidos",
  "navigation_bar.filters": "Faeddos a sa muda",
  "navigation_bar.follow_requests": "Rechestas de sighidura",
  "navigation_bar.followed_tags": "Etichetas sighidas",
  "navigation_bar.follows_and_followers": "Gente chi sighis e sighiduras",
  "navigation_bar.import_export": "Importatzione e esportatzione",
  "navigation_bar.lists": "Listas",
  "navigation_bar.live_feed_local": "Canale in direta (locale)",
  "navigation_bar.live_feed_public": "Canale in direta (pùblicu)",
  "navigation_bar.logout": "Essi",
  "navigation_bar.moderation": "Moderatzione",
  "navigation_bar.more": "Àteru",
  "navigation_bar.mutes": "Persones a sa muda",
  "navigation_bar.opened_in_classic_interface": "Publicatziones, contos e àteras pàginas ispetzìficas sunt abertas in manera predefinida in s'interfache web clàssica.",
  "navigation_bar.preferences": "Preferèntzias",
  "navigation_bar.search": "Chirca",
  "navigation_bar.search_trends": "Chirca / in tendèntzia",
  "not_signed_in_indicator.not_signed_in": "Ti depes identificare pro atzèdere a custa resursa.",
  "notification.admin.report": "{name} at sinnaladu a {target}",
  "notification.admin.report_account": "{name} at sinnaladu {count, plural, one {una publicatzione} other {# publicatziones}} dae {target} pro {category}",
  "notification.admin.report_account_other": "{name} at sinnaladu {count, plural, one {una publicatzione} other {# publicatziones}} dae {target}",
  "notification.admin.report_statuses": "{name} at sinnaladu a {target} pro {category}",
  "notification.admin.report_statuses_other": "{name} at sinnaladu a {target}",
  "notification.admin.sign_up": "{name} at aderidu",
  "notification.admin.sign_up.name_and_others": "{name} e {count, plural, one {un'àtera persone} other {àteras # persones}} si sunt registradas",
  "notification.favourite": "{name} at marcadu comente a preferidu s'istadu tuo",
  "notification.favourite.name_and_others_with_link": "{name} e <a>{count, plural, one {un'àtera persone} other {àteras # persones}}</a> ant marcadu sa publicatzione tua comente preferida",
  "notification.follow": "{name} ti sighit",
  "notification.follow_request": "{name} at dimandadu de ti sighire",
  "notification.follow_request.name_and_others": "{name} e {count, plural, one {un'àtera persone} other {àteras # persones}} ant pedidu de ti sighire",
  "notification.label.mention": "Mèntovu",
  "notification.label.private_mention": "Mèntovu privadu",
  "notification.label.private_reply": "Risposta privada",
  "notification.label.reply": "Risposta",
  "notification.mention": "Mèntovu",
  "notification.moderation-warning.learn_more": "Àteras informatziones",
  "notification.moderation_warning": "T'ant imbiadu un'avisu de moderatzione",
  "notification.moderation_warning.action_delete_statuses": "Unas cantas de is publicatziones tuas sunt istadas cantzelladas.",
  "notification.moderation_warning.action_disable": "Su contu tuo est istadu disativadu.",
  "notification.moderation_warning.action_mark_statuses_as_sensitive": "Unas cantas de is publicatziones tuas sunt istadas marcadas comente sensìbiles.",
  "notification.moderation_warning.action_none": "Su contu tuo at retzidu un'avisu de moderatzione.",
  "notification.moderation_warning.action_sensitive": "Is publicatziones tuas ant a èssere marcadas comente sensìbiles dae immoe.",
  "notification.moderation_warning.action_silence": "Su contu tuo est istadu limitadu.",
  "notification.moderation_warning.action_suspend": "Su contu tuo est istadu suspèndidu.",
  "notification.own_poll": "Sondàgiu acabbadu",
  "notification.poll": "Unu sondàgiu in su chi as votadu est acabbadu",
  "notification.reblog": "{name} at cumpartzidu sa publicatzione tua",
  "notification.reblog.name_and_others_with_link": "{name} e <a>{count, plural, one {un'àtera persone} other {àteras # persones}}</a> ant potentziadu sa publicatzione tua",
  "notification.relationships_severance_event": "Connessiones pèrdidas cun {name}",
  "notification.relationships_severance_event.account_suspension": "S'amministratzione de {from} at suspèndidu a {target}; custu bolet nàrrere chi non podes prus retzire atualizatziones dae in cue o interagire cun cussos contos.",
  "notification.relationships_severance_event.domain_block": "S'amministratzione de {from} at blocadu a {target}, incluende {followersCount} sighiduras tuas e {followingCount, plural, one {un'àteru contu} other {àteros # contos}} chi sighis.",
  "notification.relationships_severance_event.learn_more": "Àteras informatziones",
  "notification.relationships_severance_event.user_domain_block": "As blocadu a {target}, bogadu a {followersCount} contos chi ti sighint e {followingCount, plural, one {un'àteru contu} other {àteros # contos}} chi sighis.",
  "notification.status": "{name} at publicadu cosa",
  "notification.update": "{name} at modificadu una publicatzione",
  "notification_requests.accept": "Atzeta",
  "notification_requests.accept_multiple": "{count, plural, one {Atzeta una rechesta…} other {Atzeta # rechestas…}}",
  "notification_requests.confirm_accept_multiple.button": "{count, plural, one {Atzeta sa rechesta} other {Atzeta is rechestas}}",
  "notification_requests.confirm_accept_multiple.message": "Ses atzetende {count, plural, one {una rechesta de notìfica} other {# rechestas de notìfica}}. Seguru chi boles sighire?",
  "notification_requests.confirm_accept_multiple.title": "Boles atzetare is rechestas de notìfica?",
  "notification_requests.confirm_dismiss_multiple.button": "{count, plural, one {Iscarta sa rechesta} other {Iscarta is rechestas}}",
  "notification_requests.confirm_dismiss_multiple.message": "Ses acanta de iscartare {count, plural, one {una rechesta de notìfica} other {# rechestas de notìfica}}. No nche {count, plural, one {} other {}} as a pòdere prus atzèdere in manera sèmplitze. Seguru chi boles sighire?",
  "notification_requests.confirm_dismiss_multiple.title": "Boles iscartare is rechestas de notìfica?",
  "notification_requests.dismiss": "Iscarta",
  "notification_requests.dismiss_multiple": "{count, plural, one {Iscarta una rechesta…} other {Iscarta # rechestas…}}",
  "notification_requests.edit_selection": "Modifica",
  "notification_requests.exit_selection": "Fatu",
  "notification_requests.explainer_for_limited_account": "Is notìficas de custu contu sunt istadas filtradas, ca su contu est istadu limitadu dae sa moderatzione.",
  "notification_requests.explainer_for_limited_remote_account": "Is notìficas de custu contu sunt istadas filtradas, ca su contu o su serbidore suo est istadu limitadu dae sa moderatzione.",
  "notification_requests.maximize": "Ismànnia",
  "notification_requests.minimize_banner": "Mìnima su bànner de notìficas filtradas",
  "notification_requests.notifications_from": "Notìficas dae {name}",
  "notification_requests.title": "Notìficas filtradas",
  "notification_requests.view": "Mustra notìficas",
  "notifications.clear": "Lìmpia notìficas",
  "notifications.clear_confirmation": "Seguru chi boles isboidare in manera permanente totu is notìficas tuas?",
  "notifications.clear_title": "Boles cantzellare is notìficas?",
  "notifications.column_settings.admin.report": "Informes noos:",
  "notifications.column_settings.admin.sign_up": "Registros noos:",
  "notifications.column_settings.alert": "Notìficas de iscrivania",
  "notifications.column_settings.favourite": "Preferidos:",
  "notifications.column_settings.filter_bar.advanced": "Ammustra totu is categorias",
  "notifications.column_settings.filter_bar.category": "Barra de filtru lestru",
  "notifications.column_settings.follow": "Sighiduras noas:",
  "notifications.column_settings.follow_request": "Rechestas noas de sighidura:",
  "notifications.column_settings.group": "Grupu",
  "notifications.column_settings.mention": "Mèntovos:",
  "notifications.column_settings.poll": "Resurtados de su sondàgiu:",
  "notifications.column_settings.push": "Notìficas push",
  "notifications.column_settings.reblog": "Cumpartziduras:",
  "notifications.column_settings.show": "Ammustra in sa colunna",
  "notifications.column_settings.sound": "Reprodue unu sonu",
  "notifications.column_settings.status": "Publicatziones noas:",
  "notifications.column_settings.unread_notifications.category": "Notìficas de lèghere",
  "notifications.column_settings.unread_notifications.highlight": "Evidèntzia is notìficas de lèghere",
  "notifications.column_settings.update": "Modìficas:",
  "notifications.filter.all": "Totus",
  "notifications.filter.boosts": "Cumpartziduras",
  "notifications.filter.favourites": "Preferidos",
  "notifications.filter.follows": "Sighende",
  "notifications.filter.mentions": "Mèntovos",
  "notifications.filter.polls": "Resurtados de su sondàgiu",
  "notifications.filter.statuses": "Atualizatziones dae gente chi sighis",
  "notifications.grant_permission": "Dona su permissu.",
  "notifications.group": "{count} notìficas",
  "notifications.mark_as_read": "Sinnala ònnia notìfica comente lèghida",
  "notifications.permission_denied": "Is notìficas de iscrivania non sunt a disponimentu pro neghe de rechestas de permissu chi sunt istadas dennegadas in antis",
  "notifications.permission_denied_alert": "Is notìficas de iscrivania non podent èssere abilitadas, ca su permissu de su navigadore est istadu dennegadu in antis",
  "notifications.permission_required": "Is notìficas de iscrivania no sunt a disponimentu ca ammancat su permissu rechèdidu.",
  "notifications.policy.accept": "Atzeta",
  "notifications.policy.accept_hint": "Mustra in is notìficas",
  "notifications.policy.filter_new_accounts.hint": "Creadu {days, plural, one {erisero} other {in is ùrtimas # dies}}",
  "notifications.policy.filter_new_accounts_title": "Contos noos",
  "notifications.policy.filter_not_followers_title": "Gente chi non ti sighit",
  "notifications.policy.filter_not_following_hint": "Fintzas a cando no donas s'aprovatzione tua",
  "notifications.policy.filter_not_following_title": "Gente chi non sighis",
  "notifications_permission_banner.enable": "Abilita is notìficas de iscrivania",
  "notifications_permission_banner.how_to_control": "Pro retzire notìficas cando Mastodon no est abertu, abilita is notìficas de iscrivania. Podes controllare cun pretzisione is castas de interatziones chi ingendrant notìficas de iscrivania pro mèdiu de su butone {icon} in subra, cando sunt abilitadas.",
  "notifications_permission_banner.title": "Non ti perdas mai nudda",
  "onboarding.follows.back": "A coa",
  "onboarding.follows.search": "Chirca",
  "onboarding.follows.title": "Sighi a gente pro cumintzare",
  "onboarding.profile.display_name": "Nòmine visìbile",
  "onboarding.profile.note": "Biografia",
  "onboarding.profile.title": "Cunfiguratzione de profilu",
  "onboarding.profile.upload_avatar": "Càrriga una fotografia de profilu",
  "picture_in_picture.restore": "Torra·ddu a ue fiat",
  "poll.closed": "Serradu",
  "poll.refresh": "Atualiza",
  "poll.reveal": "Ammustra is resurtados",
  "poll.total_people": "{count, plural, one {# persone} other {# persones}}",
  "poll.total_votes": "{count, plural, one {# votu} other {# votos}}",
  "poll.vote": "Vota",
  "poll.voted": "As votadu custa risposta",
  "poll.votes": "{votes, plural, one {# votu} other {# votos}}",
  "poll_button.add_poll": "Agiunghe unu sondàgiu",
  "poll_button.remove_poll": "Cantzella su sondàgiu",
  "privacy.change": "Modìfica s'istadu de riservadesa",
  "privacy.direct.long": "Totu is utentes mentovados in sa publicatzione",
  "privacy.private.long": "Isceti chie ti sighit",
  "privacy.private.short": "Sighiduras",
  "privacy.public.long": "Cale si siat persone a intro o a foras de Mastodon",
  "privacy.public.short": "Pùblicu",
  "privacy_policy.last_updated": "Ùrtima atualizatzione: {date}",
  "privacy_policy.title": "Polìtica de riservadesa",
  "recommended": "Cussigiadu",
  "refresh": "Atualiza",
  "relative_time.days": "{number} dies a oe",
  "relative_time.full.days": "{number, plural, one {# die} other {# dies}} a oe",
  "relative_time.full.hours": "{number, plural, one {# ora} other {# oras}} a immoe",
  "relative_time.full.just_now": "immoe immoe",
  "relative_time.full.minutes": "{number, plural, one {# minutu} other {# minutos}} a immoe",
  "relative_time.full.seconds": "{number, plural, one {# segundu} other {# segundos}} a immoe",
  "relative_time.hours": "{number} oras a immoe",
  "relative_time.just_now": "immoe",
  "relative_time.minutes": "{number} minutos a immoe",
  "relative_time.seconds": "{number} segundos a immoe",
  "relative_time.today": "oe",
  "reply_indicator.attachments": "{count, plural, one {# alligongiadu} other {# alligongiados}}",
  "reply_indicator.cancel": "Annulla",
  "reply_indicator.poll": "Sondàgiu",
  "report.block": "Bloca",
  "report.categories.legal": "Giurìdicu",
  "report.categories.other": "Àteru",
  "report.categories.spam": "Àliga",
  "report.category.subtitle": "Sèbera sa currispondèntzia prus arta",
  "report.category.title": "Nara·nos ite sutzedet cun custu {type}",
  "report.category.title_account": "profilu",
  "report.category.title_status": "publicatzione",
  "report.close": "Fatu",
  "report.comment.title": "Nch'at àteru chi depamus ischire?",
  "report.forward": "Torra a imbiare a {target}",
  "report.forward_hint": "Custu contu est de un'àteru serbidore. Ddi boles imbiare puru una còpia anònima de custu informe?",
  "report.mute": "A sa muda",
  "report.mute_explanation": "No as a bìdere is publicatziones suas. Ti podet ancora sighire e bìdere is publicatziones, ma no at a ischire chi dd'as postu a sa muda.",
  "report.next": "Imbeniente",
  "report.placeholder": "Cummentos additzionales",
  "report.reasons.dislike": "Non mi praghet",
  "report.reasons.dislike_description": "Est una cosa chi non boles bìdere",
  "report.reasons.legal": "Illegale",
  "report.reasons.other": "Un'àtera cosa",
  "report.reasons.other_description": "Su problema non currispondet a is àteras categorias",
  "report.reasons.spam": "Est àliga",
  "report.rules.subtitle": "Seletziona totu is chi àplichent",
  "report.statuses.subtitle": "Seletziona totu is chi àplichent",
  "report.submit": "Imbia",
  "report.target": "Informende de {target}",
  "report.thanks.title": "Non boles bìdere custu?",
  "report.thanks.title_actionable": "Gràtzias de sa sinnalatzione, dd'amus a averiguare.",
  "report.unfollow": "Non sigas prus a @{name}",
  "report.unfollow_explanation": "Ses sighende custu contu. Si non boles bìdere is publicatziones suas in sa pàgina printzipale tua, no ddu sigas prus.",
  "report_notification.attached_statuses": "{count, plural, one {# post} other {# posts}} attached",
  "report_notification.categories.legal": "Giurìdicu",
  "report_notification.categories.legal_sentence": "cuntenutu illegale",
  "report_notification.categories.other": "Àteru",
  "report_notification.categories.other_sentence": "àteru",
  "report_notification.categories.spam": "Àliga",
  "report_notification.categories.spam_sentence": "àliga",
  "report_notification.open": "Aberi una sinnalatzione",
  "search.no_recent_searches": "Nissuna chirca reghente",
  "search.placeholder": "Chirca",
  "search.quick_action.account_search": "Profilos chi currispondent cun {x}",
  "search.quick_action.go_to_account": "Bae a su profilu {x}",
  "search.quick_action.go_to_hashtag": "Bae a s'eticheta {x}",
  "search.quick_action.open_url": "Aberi s'URL in Mastodon",
  "search.quick_action.status_search": "Publicatziones chi currispondent cun {x}",
  "search.search_or_paste": "Chirca o incolla un'URL",
  "search_popout.full_text_search_disabled_message": "No a disponimentu a {domain}.",
  "search_popout.full_text_search_logged_out_message": "Isceti a disponimentu cun sa sessione aberta.",
  "search_popout.language_code": "Còdighe de limba ISO",
  "search_popout.options": "Optziones de chirca",
  "search_popout.quick_actions": "Atziones lestras",
  "search_popout.recent": "Chircas reghentes",
  "search_popout.specific_date": "data ispetzìfica",
  "search_popout.user": "utente",
  "search_results.accounts": "Profilos",
  "search_results.all": "Totus",
  "search_results.hashtags": "Etichetas",
  "search_results.see_all": "Bide totu",
  "search_results.statuses": "Publicatziones",
  "search_results.title": "Chirca \"{q}\"",
  "server_banner.about_active_users": "Gente chi at impreadu custu serbidore is ùrtimas 30 dies (Utentes cun Atividade a su Mese)",
  "server_banner.active_users": "utentes ativos",
  "server_banner.administered_by": "Amministradu dae:",
  "server_banner.server_stats": "Istatìsticas de su serbidore:",
  "sign_in_banner.create_account": "Crea contu",
  "sign_in_banner.sign_in": "Identificatzione",
  "status.admin_account": "Aberi s'interfache de moderatzione pro @{name}",
  "status.admin_status": "Aberi custa publicatzione in s'interfache de moderatzione",
  "status.block": "Bloca a @{name}",
  "status.bookmark": "Sinnalibru",
  "status.cancel_reblog_private": "Iscontza sa cumpartzidura",
  "status.cannot_reblog": "Custa publicatzione non podet èssere cumpartzida",
  "status.copy": "Còpia su ligòngiu a sa publicatzione tua",
  "status.delete": "Cantzella",
  "status.detailed_status": "Visualizatzione de detàlliu de arresonada",
  "status.edit": "Modìfica",
  "status.edited_x_times": "Modificadu {count, plural, one {{count} # borta} other {{count} bortas}}",
  "status.load_more": "Càrriga·nde àteros",
  "status.media_hidden": "Elementos multimediales cuados",
  "status.mention": "Mèntova a @{name}",
  "status.more": "Àteru",
  "status.mute": "Pone a @{name} a sa muda",
  "status.mute_conversation": "Pone s'arresonada a sa muda",
  "status.open": "Ismànnia custa publicatzione",
  "status.pin": "Apica in su profilu",
  "status.read_more": "Leghe·nde àteru",
  "status.reblog": "Cumpartzi",
  "status.reblogged_by": "{name} at cumpartzidu",
  "status.reblogs.empty": "Nemos at ancora cumpartzidu custa publicatzione. Cando calicunu dd'at a fàghere, at a èssere ammustrada inoghe.",
  "status.redraft": "Cantzella e torra a iscrìere",
  "status.remove_bookmark": "Boga su sinnalibru",
  "status.reply": "Risponde",
  "status.replyAll": "Risponde a su tema",
  "status.report": "Sinnala @{name}",
  "status.sensitive_warning": "Cuntenutu sensìbile",
  "status.share": "Cumpartzi",
  "status.show_less_all": "Ammustra·nde prus pagu pro totus",
  "status.show_more_all": "Ammustra·nde prus pro totus",
  "status.title.with_attachments": "{user} at publicadu {attachmentCount, plural, one {un'alligongiadu} other {{attachmentCount} alligongiados}}",
  "status.unmute_conversation": "Torra a ativare s'arresonada",
  "status.unpin": "Boga dae pitzu de su profilu",
  "subscribed_languages.save": "Sarva is modìficas",
  "tabs_bar.home": "Printzipale",
  "tabs_bar.notifications": "Notìficas",
  "time_remaining.days": "{number, plural, one {abarrat # die} other {abarrant # dies}}",
  "time_remaining.hours": "{number, plural, one {abarrat # ora} other {abarrant # oras}}",
  "time_remaining.minutes": "{number, plural, one {abarrat # minutu} other {abarrant # minutos}}",
  "time_remaining.moments": "Abarrant pagu momentos",
  "time_remaining.seconds": "{number, plural, one {abarrat # segundu} other {abarrant # segundos}}",
  "trends.counter_by_accounts": "{count, plural, one {{counter} persone} other {{counter} persones}} in {days, plural, one {s'ùrtima die} other {{days} is ùrtimas dies}}",
  "trends.trending_now": "Est tendèntzia immoe",
  "ui.beforeunload": "S'abbotzu tuo at a èssere pèrdidu si essis dae Mastodon.",
  "units.short.billion": "{count}Mrd",
  "units.short.million": "{count}Mln",
  "units.short.thousand": "{count}m",
  "upload_area.title": "Traga pro carrigare",
  "upload_button.label": "Agiunghe immàgines, unu vìdeu o unu documentu sonoru",
  "upload_error.limit": "Lìmite de càrriga de archìvios barigadu.",
  "upload_error.poll": "Non si permitit s'imbiu de archìvios in is sondàgios.",
  "upload_form.edit": "Modìfica",
  "upload_progress.label": "Carrighende...",
  "video.close": "Serra su vìdeu",
  "video.download": "Iscàrriga archìviu",
  "video.exit_fullscreen": "Essi de ischermu in mannària prena",
  "video.expand": "Ismànnia su vìdeu",
  "video.fullscreen": "Ischermu in mannària prena",
  "video.hide": "Cua vìdeu",
  "video.pause": "Pàusa",
  "video.play": "Reprodue"
}
